"use strict";
// Array Expression Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/#array-expression-operators
Object.defineProperty(exports, "__esModule", { value: true });
exports.$last = void 0;
var core_1 = require("../../../core");
var util_1 = require("../../../util");
/**
 * Returns the last element in an array.
 *
 * @param  {Object} obj
 * @param  {*} expr
 * @return {*}
 */
function $last(obj, expr, options) {
    var arr = (0, core_1.computeValue)(obj, expr, null, options);
    if (arr == null)
        return null;
    (0, util_1.assert)((0, util_1.isArray)(arr), "Must resolve to an array/null or missing");
    if (arr.length > 0)
        return arr[arr.length - 1];
    return undefined;
}
exports.$last = $last;
